exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* START EVOQ COLOR PALETTE */\n/* END EVOQ COLOR PALETTE */\n/* START ATTENTION COLORS */\n/* END ATTENTION COLORS */\n/* SVG HOVER STATES */\nsvg {\n  fill: #C8C8C8;\n}\nsvg:hover {\n  fill: #6F7273;\n}\nsvg:active {\n  fill: #1E88C3;\n}\n/* END SVG HOVER STATES */\n._2O1RgfLqnNhQfiHMq8m4tA .left-column * {\n  box-sizing: content-box;\n}\n._2O1RgfLqnNhQfiHMq8m4tA .item-picker-container * {\n  box-sizing: border-box !important;\n}\n", ""]);

// Exports
exports.locals = {
	"pageFile": "_2O1RgfLqnNhQfiHMq8m4tA"
};